import React, { useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClickAwayListener } from "@mui/material";
import { faInfo, faQuestion } from "@fortawesome/pro-solid-svg-icons";
import { TextVariant, TypographyNew } from "../typography/typography";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { flapOut } from "../../utils/z-index";
import Popper from "../popper/Popper";

const TooltipContainer = styled.div<{ active: boolean }>`
  position: relative;
  width: 20px;
  height: 20px;
  background-color: ${(props) =>
    props.active ? props.theme.colors.misc1 : props.theme.colors.misc2};
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  &:hover {
    background-color: ${(props) => props.theme.colors.misc1};
    cursor: pointer;
  }
`;

const Tip = styled.div<{ $fullWidth?: boolean }>`
  width: ${(props) => !props.$fullWidth && "200px"};
  min-height: 40px;
  padding: 10px;
  border: 1px solid ${(props) => props.theme.colors.grays4};
  box-shadow: 0px 8px 16px #4c4c4c24;
  border-radius: ${(props) => props.theme.borderRadius.small};
  background-color: ${(props) => props.theme.colors.white};
  margin: 5px;
  z-index: ${flapOut};
`;

const QUESTION_TYPE = "question";
const INFO_TYPE = "info";

export interface TooltipNewProps {
  fullWidth?: boolean;
  message: string | React.ReactElement;
  className?: string;
  type?: typeof QUESTION_TYPE | typeof INFO_TYPE;
}

const TooltipNew = (props: TooltipNewProps): JSX.Element => {
  const { type = QUESTION_TYPE } = props;
  const [show, setShow] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const icon = type === INFO_TYPE ? faInfo : faQuestion;

  return (
    <TooltipContainer
      className={props.className}
      ref={ref}
      onClick={() => setShow(!show)}
      active={show}
    >
      <FontAwesomeIcon
        icon={icon as IconProp}
        size={"xs"}
        color={theme.colors.primary1}
      />
      <Popper open={show} anchorEl={ref.current}>
        <ClickAwayListener onClickAway={() => setShow(false)}>
          <Tip $fullWidth={props.fullWidth}>
            <TypographyNew variant={TextVariant.body1}>
              {props.message}
            </TypographyNew>
          </Tip>
        </ClickAwayListener>
      </Popper>
    </TooltipContainer>
  );
};

export default TooltipNew;
